export function formatDateLocale(value: any, locale = 'en-AU') {
  return new Date(value).toLocaleDateString(locale);
}

/**
 * Format a date with custom format options
 */
export function formatDate(value: any, format?: Intl.DateTimeFormatOptions, locale = 'en-AU') {
  if (!value) return '';

  // If no format provided, use a default readable format
  if (!format) {
    return new Date(value).toLocaleDateString(locale, {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    });
  }

  return new Intl.DateTimeFormat(locale, format).format(new Date(value));
}
